<article class="w-full h-screen flex flex-column justify-content-center align-items-center gap-3">
  <section *ngIf="pluviometer && show"
    class="w-full fadein animation-duration-500	bg-black-alpha-10 border-round-2xl p-2 py-3 md:p-4 shadow-3 relative">
    <h3 class="text-center ci-txt--black text-xl md:text-2xl">
      {{pluviometer.name}}
    </h3>

    <section class="flex gap-2 mt-4 justify-content-between md:justify-content-center">
      <section *ngIf="pluviometer?.temperature"
        class="w-6rem mx-auto flex flex-column justify-content-center align-items-center gap-2 bg-white-alpha-50 shadow-1 border-round-2xl py-2 md:p-2">
        <span>
          <i class="bi bi-thermometer-sun text-4xl md:text-5xl ci-txt--red"></i>
        </span>

        <section class="flex flex-column text-sm md:text-base font-semibold text-center ci-txt--black">
          <span *ngIf="pluviometer.temperature" class="fadein animation-duration-1000">
            {{pluviometer.temperature}} °C
          </span>

          <small class="m-1 ci-txt--grey">
            Temp.
          </small>
        </section>
      </section>

      <section *ngIf="pluviometer?.precipitation"
        class="w-6rem mx-auto flex flex-column justify-content-center align-items-center gap-2 bg-white-alpha-50 shadow-1 border-round-2xl py-3 md:p-3">
        <span>
          <i class="bi bi-cloud-drizzle text-4xl md:text-5xl ci-txt--blue"></i>
        </span>

        <section class="flex flex-column text-sm md:text-base font-semibold text-center ci-txt--black">
          <span *ngIf="pluviometer.precipitation" class="fadein animation-duration-1000">
            {{pluviometer.precipitation}} mm
          </span>

          <small class="m-1 ci-txt--grey">
            Precip.
          </small>
        </section>
      </section>

      <section *ngIf="pluviometer?.relativeHumidity"
        class="w-6rem mx-auto flex flex-column justify-content-center align-items-center gap-2 bg-white-alpha-50 shadow-1 border-round-2xl py-3 md:p-3">
        <span>
          <i class="bi bi-droplet-half text-4xl md:text-5xl ci-txt--blue-lighten"></i>
        </span>

        <section class="flex flex-column text-sm md:text-base font-semibold text-center ci-txt--black">
          <span *ngIf="pluviometer.relativeHumidity" class="fadein animation-duration-1000">
            {{pluviometer.relativeHumidity}} %RH
          </span>

          <small class="mt-1 ci-txt--grey">
            Humedad rel.
          </small>
        </section>
      </section>
    </section>

    <section *ngIf="pluviometer.temperature !== ''" class="absolute top-0 right-0 mr-3 mt-3">
      <i class="bi bi-arrow-repeat cursor-pointer text-2xl ci-txt--black-lighten" (click)="reloadData()">
      </i>
    </section>

    <section
      *ngIf="pluviometer?.temperatureMessage || pluviometer?.precipitationMessage || pluviometer?.relativeHumidityMessage"
      class="w-full mt-3 fadein animation-duration-500">
      <marquee>
        <section class="flex align-items-center gap-3">
          <section *ngIf="pluviometer?.temperatureMessage" class="flex align-items-center gap-2">
            <i class="bi bi-thermometer-sun text-xl ci-txt--red"></i> {{pluviometer.temperatureMessage}}
          </section>

          <section *ngIf="pluviometer?.precipitationMessage" class="flex align-items-center gap-2">
            <i class="bi bi-cloud-drizzle text-xl ci-txt--blue"></i> {{pluviometer.precipitationMessage}}
          </section>

          <section *ngIf="pluviometer?.relativeHumidityMessage" class="flex align-items-center gap-2">
            <i class="bi bi-droplet-half text-xl ci-txt--blue-lighten"></i> {{pluviometer.relativeHumidityMessage}}
          </section>
        </section>
      </marquee>
    </section>
  </section>

  <section *ngIf="!pluviometer && !show"
    class="ci-txt--grey flex flex-column align-items-center justify-content-center">
    <section class="ci-rotate">
      <i class="bi bi-hourglass text-6xl"></i>
    </section>

    <h4 class="text-2xl ci-txt--black-lighten mt-2 text-center font-normal">
      Cargando...
    </h4>
  </section>

  <section *ngIf="emptyState" class="flex flex-column align-items-center justify-content-center">
    <section>
      <i class="bi bi-exclamation-triangle ci-txt--red text-6xl"></i>
    </section>

    <h4 class="text-2xl ci-txt--black mt-2 text-center">
      Error Pluviómetro
    </h4>

    <p class="text-xl ci-txt--black-lighten mt-2 text-center">
      No hay información relacionada que mostrar
    </p>
  </section>
</article>